import calculateMenuPosition from './calculate-context-menu-position';

const createPositionCalculator = (controlPane, triggerRef) => (menuElement) => {
  const { position, direction } = controlPane;
  const { left } = triggerRef.current.getBoundingClientRect();

  return calculateMenuPosition({
    menuElement,
    controlPanePosition: {
      x: left - 3,
      y: position.y,
    },
    direction,
  });
};

export default createPositionCalculator;
